export default function AppSection() {
  return (
    <section id="app" className="flex flex-col lg:flex-row">
      <div className="w-full lg:w-[50%] bg-background-800 py-20 md:py-28 px-6 md:px-16 flex flex-col justify-center">
        <span className="text-xs font-medium text-foreground-600 tracking-wider uppercase mb-4">
          移动端入口
        </span>
        <h2 className="font-heading font-black text-foreground-950 leading-none">
          <span className="block text-5xl md:text-7xl">五一</span>
          <span className="block text-3xl md:text-4xl mt-2">吃瓜</span>
          <span className="block text-5xl md:text-6xl mt-1 text-accent-800">APP</span>
        </h2>
        <p className="mt-6 text-sm text-foreground-600 leading-relaxed max-w-[360px]">
          下载五一吃瓜网官方APP，随时随地掌握全网最新吃瓜动态。支持推送通知、离线阅读、夜间模式，吃瓜体验全面升级。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
          <button className="px-7 py-3 rounded-full bg-foreground-950 text-background-50 font-bold text-sm hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer">
            <i className="ri-apple-fill mr-1.5"></i>
            App Store
          </button>
          <button className="px-7 py-3 rounded-full border border-foreground-800/30 text-foreground-900 font-bold text-sm hover:border-accent-500 hover:text-accent-800 transition-all duration-200 whitespace-nowrap cursor-pointer">
            <i className="ri-android-fill mr-1.5"></i>
            Google Play
          </button>
        </div>
      </div>

      <div className="w-full lg:w-[50%] bg-background-700 py-20 md:py-28 px-6 md:px-16 flex flex-col items-center justify-center text-center">
        <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-950 leading-tight">
          随时随地
          <br />
          在线吃瓜
        </h2>
        <p className="mt-5 text-sm text-foreground-600 leading-relaxed max-w-[340px]">
          五一吃瓜网APP已覆盖 iOS 和 Android 双平台，支持推送通知、暗黑模式、离线缓存等专属功能，让你在通勤、排队、睡前随时随地追热点吃大瓜。
        </p>
        <div className="mt-8 flex items-center gap-4">
          <div className="w-32 h-32 bg-background-700 rounded-2xl border border-foreground-800/20 flex items-center justify-center">
            <span className="text-xs text-foreground-500">扫码下载</span>
          </div>
        </div>
      </div>
    </section>
  );
}